module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Praise_Praise-heading",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("Praise for ")]), _c('span', {
    staticClass: "BoldItalics _idGenCharOverride-1"
  }, [_vm._v("Black and Resilient")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise_Praise-Quote"
  }, [_vm._v("“We need more books like this—books that speak directly to our Black youth and teach them the critical skills they need to survive being Black in America. In "), _c('span', {
    staticClass: "BookItalics _idGenCharOverride-2"
  }, [_vm._v("Black and Resilient: 52 Weeks of Anti-Racist Activities for Black Joy and Empowerment")]), _vm._v(", educator M.J. Fievre has built a toolkit for survival that will help Black boys learn crucial lessons, like how to channel their frustrations in a positive direction and how to reflect upon their lives for greater clarity. This book should be in every public library and every school in America. It is an essential part of an education our Black boys need and often don’t get.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise_Praise-Author"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("—Geoffrey Philp, author of ")]), _c('span', {
    staticClass: "BoldItalics _idGenCharOverride-1"
  }, [_vm._v("My Name Is Marcus")]), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v(", a graphic novel for children")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise_Praise-Quote"
  }, [_vm._v("“If you have a Black boy in your life who struggles with self-esteem or with fitting in, buy this book! In "), _c('span', {
    staticClass: "BookItalics _idGenCharOverride-2"
  }, [_vm._v("Black and Resilient")]), _vm._v(" M.J. Fievre breaks down the notions that keep our Black boys from reaching their fullest potential and does so with candor and wit. The exercises she has designed will help your child see the hypocrisy and futility of racism and encourage your boys to reach their highest potential without becoming jaded and dissatisfied with their lot in life. She clearly explains the challenges facing Black youth and does so in a way that is not defeatist but encourages them to rise above all the stereotypical nonsense they face on a day-to day basis and emerge triumphant.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise_Praise-Author"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("—Just Mike the Poet, author of ")]), _c('span', {
    staticClass: "BoldItalics _idGenCharOverride-1"
  }, [_vm._v("Dear Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise_Praise-Quote"
  }, [_vm._v("“In her latest book, "), _c('span', {
    staticClass: "BookItalics _idGenCharOverride-2"
  }, [_vm._v("Black and Resilient: 52 Weeks of Anti-Racist Activities for Black Joy and Empowerment")]), _vm._v(", bestselling author M.J. Fievre has written a book that will be appreciated by Black boys everywhere. In the book, she encourages Black boys to learn about racism and gives them the means to build resilience and joy: two qualities that every child needs. By working through them, those boys actually gain the experience of dealing with their own emotions, and with an often-hostile world, preparing themselves without the damage of actual confrontation. This is a direct, no-fluff approach to combating racism and building self-esteem. Fievre gives great advice, and the activities she has written for them will help them find solid footing and become strong, loving, capable adults.”")]), _vm._v(" "), _c('p', {
    staticClass: "Praise_Praise-Author _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v("—Steven Barnes, author of ")]), _c('span', {
    staticClass: "BoldItalics _idGenCharOverride-1"
  }, [_vm._v("Lion’s Blood")]), _c('span', {
    staticClass: "Bold _idGenCharOverride-1"
  }, [_vm._v(" and ")]), _c('span', {
    staticClass: "BoldItalics _idGenCharOverride-1"
  }, [_vm._v("Afrofuturist")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5016ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlackAndResilient.vue
// module id = 60
// module chunks = 0